export const formatSSN = ssn => {
    if (!ssn) return '           ';
    const start = ssn.substring(0, 3);
    const middle = ssn.substring(3, 5);
    const end = ssn.substring(5);
    return `${start}-${middle}-${end}`;
};
